import { wsName } from "..";
import { WsConfiguration } from "./WsConfiguration";
import Cookies from "js-cookie";

export default class WsConnection {
  configuration: WsConfiguration;
  socket: WebSocket;
  connected: boolean;
  pingTimer: NodeJS.Timeout;

  start = (config: WsConfiguration): boolean => {
    this.configuration = config;
    this.connect();
    return true;
  };

  stop = () => {
    this.socket.close();
  };

  getEventName = (messageType: string) => {
    return `${wsName}::${messageType}`;
  };

  sendMessage = (type: string, data?: object) => {
    let message = Object.assign({ messageType: type }, data);
    let json = JSON.stringify(message);
    this.socket.send(json);
    if (data) {
      this.log("WebSockets sent", data);
    }
  };

  subscribe = (messageType: string, handler: (e: CustomEvent) => void) => {
    window.addEventListener(this.getEventName(messageType), handler);
  };

  unsubscribe = (messageType: string, handler: (e: CustomEvent) => void) => {
    window.removeEventListener(this.getEventName(messageType), handler);
  };
  
  sendAuthorizationMessage = () => {
    const authToken = Cookies.get("AuthToken");
    this.sendMessage("Authorize", {
      authToken
    });
  }

  private connect() {
    if (this.connected) {
      this.log("WebSockets already connected");
      return;
    }
    
    if(!navigator.onLine) {
      this.log("No internet connection, trying again later...");
      setTimeout(() => {
        this.connect();
      }, this.configuration.reconnectionInterval);
      return;
    }
    
    if (this.socket) {
      this.log("Socket is closed before creating a new one");
      this.socket.onclose = null;
      this.socket.close();
    }
    
    this.socket = new WebSocket(this.configuration.url());
    let pingTimer: any = null;
    
    this.socket.onopen = () => {
      this.connected = true;
      this.log("WebSockets connected");
      if (this.configuration.applicationName != "UserManagement") {
        if (this.socket.readyState == 1) {
          this.sendAuthorizationMessage();
        } else {
          this.log("Socket state is not connected, authorization for UM is skipped and socket will be closed");
          if (this.socket) {
            this.socket.onclose = null;
            this.socket.close();
          }
          return;
        }
      }
      if (this.configuration.shouldRefreshOnReconnect) {
        location.reload();
      }
      
      pingTimer = setInterval(() => {
        if (this.socket.readyState == 1) {
          //OPEN
          this.sendMessage("ping");
        } else if (this.socket.readyState == 2 || this.socket.readyState == 3) {
          //CLOSING, CLOSED
          clearInterval(pingTimer);
        }
      }, this.configuration.pingInterval);
    };

    this.socket.onerror = e => {
      const connectionErrorEvent = new CustomEvent('umWebSocketConnectionError', {
        detail: { error: e },
      });

      window.dispatchEvent(connectionErrorEvent);

      this.socket.onclose = null;
      this.socket.close();
      clearInterval(pingTimer);
      this.onDisconnect(e);
    };

    this.socket.onclose = e => {
      clearInterval(pingTimer);
      this.onDisconnect(e);
    };

    this.socket.onmessage = e => {
      this.onMessage(e);
    };
  }

  private onDisconnect(e: Event) {
    if (this.connected) {
      this.log("WebSockets disconnected", e);
    }

    this.connected = false;
    setTimeout(() => {
      this.connect();
    }, this.configuration.reconnectionInterval);
  }

  private onMessage(e: MessageEvent) {
    if (e.data) {
      let data = JSON.parse(e.data);
      this.log("WebSockets received", data);
      if (data.messageType) {
        var messageName = this.getEventName(data.messageType);
        var event = new CustomEvent(messageName, {
          detail: data,
        });
        window.dispatchEvent(event);
      }
    }
  }

  private log(message: string, data?: object) {
    if (data) {
      console.log(`${message}: `, data);
    } else {
      console.log(message);
    }
  }
}
